import { motion } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import { FEATURED } from "../../data/experiences";
import { Reveal, Eyebrow } from "./Reveal";

export default function FeaturedExperience({ onSchedule }) {
  return (
    <section id="experience" className="py-24 md:py-32 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 relative order-2 lg:order-1">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="rounded-[2.5rem] overflow-hidden shadow-[0_40px_80px_-35px_rgba(73,53,72,0.35)] aspect-[5/4]"
              data-testid="featured-experience-image"
            >
              <img src={FEATURED.image} alt="Resident and family portrait event at a senior living community" className="h-full w-full object-cover" />
            </motion.div>
            <div className="absolute -bottom-5 -right-4 md:-right-8 bg-marigold text-charcoal rounded-3xl px-6 py-4 shadow-xl">
              <p className="flex items-center gap-2 font-poppins font-bold text-lg leading-tight">
                <Clock size={18} /> 90 minutes
              </p>
              <p className="text-charcoal/70 text-sm">on location, professionally hosted</p>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <Reveal>
              <Eyebrow>The Experience</Eyebrow>
              <h2 data-testid="featured-title" className="mt-5 font-poppins font-bold text-charcoal text-4xl md:text-5xl lg:text-[3.25rem] leading-[1.08] tracking-tight">
                Resident &amp; Family Portrait Events for Senior Living Communities
              </h2>
              <p data-testid="featured-package-name" className="mt-4 inline-block rounded-full bg-sky/40 text-charcoal font-semibold px-4 py-1.5 text-sm">
                Package: {FEATURED.title}
              </p>
              <p className="mt-6 text-lg md:text-xl leading-relaxed text-charcoal/75 max-w-xl">
                {FEATURED.desc}
              </p>
              <button
                data-testid="featured-schedule-btn"
                onClick={onSchedule}
                className="mt-9 group inline-flex items-center gap-2 rounded-full bg-coral text-cream font-semibold text-lg px-8 py-4 transition-all hover:-translate-y-1 hover:shadow-[0_24px_44px_-16px_rgba(240,125,106,0.6)]"
              >
                Request a 15-Minute Conversation
                <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
